import React from 'react';
export const MainSidebarContext = React.createContext({
  isSidebarOpen: false,
  setSidebarOpen: (isOpen: boolean) => {
    // console.log('setSidebarOpen', isOpen);
  }
});